import { Button, Dialog, Divider, Menu, MenuItem, useTheme } from '@material-ui/core';
import moment from 'moment';

const white = '#ffffff';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { requestSignout } from '../actions';
import { PageDialogLink } from '../common/page-dialog-link';
import { previousWeekday } from '../common/timestamp';
import { useReduxDispatch } from '../hooks/use-redux';
import { useSession } from '../hooks/use-session';
import { UserMetrics } from './metrics/user-metrics';
import { UserDailyActivity } from './user-daily-activity';

export const HeaderUserName = () => {
    const theme = useTheme();
    const { user } = useSession();
    const dispatch = useReduxDispatch();
    const [anchor, setAnchor] = React.useState<null | HTMLElement>(null);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const [activityDialogState, setActivityDialogState] = React.useState<number>(null);

    const lastDay = previousWeekday();

    const handleMenuButtonTap = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setAnchor(event.currentTarget);
        setMenuOpen(true);
    };

    const handleSignoutClick = (event: React.SyntheticEvent<{}>) => {
        event.preventDefault();
        dispatch(requestSignout());
    };

    const handleActivityClick = (ts: number) => () => {
        setMenuOpen(false);
        setActivityDialogState(ts);
    };

    const handleCloseActivityDialog = () => setActivityDialogState(null);
    const handleMenuRequestClose = () => {
        setMenuOpen(false);
    };

    const userButtonStyles: React.CSSProperties = {
        borderRadius: '2px',
        color: white
    };

    const activityDialogContent = activityDialogState ? (
        <UserDailyActivity user={user} time={activityDialogState} />
    ) : null;

    const activityDialog = (
        <Dialog open={!!activityDialogState} onClose={handleCloseActivityDialog}>
            {activityDialogContent}
        </Dialog>
    );

    return (
        <>
            <Button style={userButtonStyles} onClick={handleMenuButtonTap}>
                {user.name.first}
            </Button>

            <Menu anchorEl={anchor} open={menuOpen} onClose={handleMenuRequestClose}>
                <MenuItem onClick={handleActivityClick(moment().valueOf())}>Today's Activity</MenuItem>
                <MenuItem onClick={handleActivityClick(lastDay.valueOf())}>
                    {lastDay.format('dddd')}'s Activity
                </MenuItem>
                <MenuItem>
                    <PageDialogLink
                        url={`/user/${user.username}/metrics`}
                        Component={UserMetrics}
                        componentProps={{ username: user.username }}
                    >
                        Recruiting Metrics
                    </PageDialogLink>
                </MenuItem>
                <Divider />
                <MenuItem>
                    <Link to="/account" style={{ color: theme.palette.text.primary }}>
                        Settings
                    </Link>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleSignoutClick}>Sign out</MenuItem>
            </Menu>
            {activityDialog}
        </>
    );
};
